angular.module('cfn').directive('cfnEditEmail', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        change: '&'
      },
      template:
        '<div class="row nomargin">' +
        '<div class="span4"><cfn-input-enum change="change()" class="input-block-level" id="value" model="item.type" enum-name="EmailTypeEnum" options="options"/></div>' +
        '<div class="span6"><cfn-input-text change="change()" class="input-block-level" id="value" model="item.value"/></div>' +
        '</div>',
      link: function(scope, element, attrs) {
        scope.options = $rootScope.enums.EmailTypeEnum.options;
      }
    };
  }
]);

angular.module('cfn').directive('cfnEditTelephone', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        change: '&'
      },
      template:
        '<div class="row nomargin">' +
        '<div class="span4"><cfn-input-enum change="change()" class="input-block-level" id="value" model="item.type" enum-name="TelTypeEnum" options="options"/></div>' +
        '<div class="span6"><cfn-input-text change="change()" class="input-block-level" id="value" model="item.value" /></div>' +
        '</div>',
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;
        scope.options = $rootScope.enums.TelTypeEnum.options;
      }
    };
  }
]);

angular.module('cfn').directive('cfnDisplayAddress', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        skipType: '='
      },
      templateUrl: require('./cfn-display-address.tpl.html'),
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;
      }
    };
  }
]);

angular.module('cfn').directive('cfnEditAddress', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        skipType: '@'
      },
      templateUrl: require('./cfn-edit-address.tpl.html'),
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;
      }
    };
  }
]);

angular.module('cfn').directive('cfnDisplayContact', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        skipType: '='
      },
      templateUrl: require('./cfn-display-contact.tpl.html'),
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;
      }
    };
  }
]);

angular.module('cfn').directive('cfnEditContacts', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        skipType: '@'
      },
      templateUrl: require('./cfn-edit-contact.tpl.html'),
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;
      }
    };
  }
]);

angular.module('cfn').directive('cfnEditNotificationdeliveryentry', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        change: '&'
      },
      template:
        '<div class="row nomargin">' +
        "<div class='row nomargin'><div class='span4'><label>{{'fe.core.notification.channel' | i18n : 'Channel'}}</label></div>" +
        "<div class='span6'>{{'fe.core.notification.channel.'+item.channelType | i18n : item.channelType}}</div></div>" +
        '<div class="row nomargin" >' +
        "<div class='span4'><label>{{'fe.core.notification.recipient' | i18n : 'Recipient'}}</label></div>" +
        "<div class='span6'><label>{{'fe.core.notification.address' | i18n : 'Address'}}</label></div>" +
        '</div>' +
        '<div class="row nomargin" ng-repeat="recipient in item.recipients">' +
        '<div class="span4">{{recipient.personName}}</div>' +
        '<div class="span6">{{recipient.personAddress}}</div>' +
        '</div>' +
        '</div>',
      link: function(scope, element, attrs) {
        scope.options = $rootScope.enums.ChannelTypeEnum.options;
      }
    };
  }
]);
